import { combineReducers } from 'redux';

import app from './app.reducer';
import config from './config.reducer';
import modal from './modal.reducer';
import notification from './notification.reducer';
import pages from './pages.reducer';
import popups from './popups.reducer';

const rootReducer = combineReducers({
	app,
	config,
	modal,
	notification,
	pages,
	popups,
});

export default rootReducer;
